// src/components/UserContractView/constants/contractConstants.js

export const BLITZ_ROOT = process.env.REACT_APP_PUBLIC_ROOT || window.location.origin;

export const CONTRACT_STATUS = {
  PENDING: 'pending',
  SIGNED: 'signed',
  AGREED: 'agreed',
  DECLINED: 'declined',
  EXPIRED: 'expired',
};

export const CONTRACT_TYPE = {
  SIMPLE: 'simple',
  STANDARD: 'standard',
};

export const ASSIGNMENT_SCOPE = {
  SPECIFIC_USERS: 'specific_users',
  PUBLIC: 'public',
};

export const SEARCH_TYPE = {
  EMAIL: 'email',
  NAME: 'name',
  USERNAME: 'username',
};

export const RECIPIENT_TYPE = {
  EXISTING: 'existing',
  NEW_EMAIL: 'new-email',
};

export const FILTER_OPTIONS = {
  ALL: 'all',
  SIGNED: 'signed',
  AGREED: 'agreed',
  DECLINED: 'declined',
};